<form *transloco="let t">
  @for(item of formGroup.items; let i = $index; track item; let last = $last) {
    <div class="row g-0 mb-3">
      <div class="col-lg-10 col-md-12 pe-2">
        <div class="mb-3">
          <label for="item--{{i}}" class="visually-hidden">{{label()}}</label>
          <input
            type="text"
            class="form-control"
            [formField]="item"
            id="item--{{i}}" />

          <app-validation-errors inputId="item--{{i}}" [control]="item" [messages]="messages()" />
        </div>
      </div>
      <div class="col-lg-2">
        <button type="button"
          class="btn btn-danger me-2"
          (click)="remove(i)"
          [disabled]="disableRemove()">
          <i class="fa-solid fa-trash" aria-hidden="true"></i>
          <span class="visually-hidden">{{t('common.remove')}}</span>
        </button>
        @if (last){
          <button type="button" class="btn btn-secondary" (click)="add()">
            <i class="fa-solid fa-plus" aria-hidden="true"></i>
            <span class="visually-hidden">{{t('common.add')}}</span>
          </button>
        }
      </div>
    </div>
  }
</form>
